import { Service } from '@angular/core';

/** Acceso tipado a localStorage, equivalente al DbService de FrontKordata. */
@Service()
export class DbService {
  private readonly storage = globalThis.localStorage as Storage | undefined;

  get<T>(key: string): T | null {
    const raw = this.storage?.getItem(key);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  set(key: string, value: unknown): void {
    this.storage?.setItem(key, JSON.stringify(value));
  }

  delete(key: string): void {
    this.storage?.removeItem(key);
  }
}
